'use client';

import { Grid, Container } from '@mui/material';
import { useState } from 'react';
import DropdownMenuMobile from './DropdownMenuMobile';
import PrimaryNav from './PrimaryNav';
import BrandIcon from './BrandIcon';
import CartIcon from './CartIcon';

/**
 * @name MainNavContainer
 * @description Main container for top navs and drop down nav list
 * @param {object} root0  - destructured object
 * @param {object} root0.icons - Data from Strapi
 * @param {boolean} root0.nav - Data from Strapi
 * @param {object} root0.leftNav - Left Navs from top navigation
 * @param {object} root0.rightNav - Right Navs from top navigation
 * @param {string} root0.cartTitle - Data from Strapi to display cart title
 * @returns {JSX.Element} Next.js Image Element
 */
const MainNavContainer = ({ nav, leftNav, rightNav, icons, cartTitle }) => {
  const [expand, setExpand] = useState(false);

  /**
   * @function handleExpand
   * @description - Function to expand and collapse drop down
   */
  const handleExpand = () => {
    setExpand(!expand);
  };
  return (
    <Container maxWidth='lg'>
      <Grid container justifyContent='space-between' alignItems='center'>
        <Grid item xs={2} sx={{ display: 'flex' }}>
          <BrandIcon icons={icons} />
        </Grid>
        <Grid item xs='auto' sm={8} md={8} sx={{ display: { xs: 'none', md: 'block' } }}>
          <PrimaryNav navs={nav} />
        </Grid>
        <Grid item xs={3} sm='auto'>
          <CartIcon
            icons={icons}
            cartTitle={cartTitle}
            expand={expand}
            handleExpand={handleExpand}
          />
        </Grid>
        <Grid item xs={12} sx={{ display: { xs: 'block', md: 'none' } }}>
          <DropdownMenuMobile
            nav={nav}
            expand={expand}
            leftNav={leftNav}
            rightNav={rightNav}
            handleExpand={handleExpand}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

MainNavContainer.displayName = 'MainNavContainer';
export default MainNavContainer;
